/* eslint-disable max-len */
import React from 'react';
function LogOut() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M13 0H0V1V2V22H2H13H15V20V16H13V20H2V2H13V6H15V2V0H13ZM15.5355 14.4853L16.9497 15.8995L20.4852 12.364L21.8995 10.9497L20.4852 9.53553L16.9497 6L15.5355 7.41421L18.1212 9.99996H7V12H18.0208L15.5355 14.4853Z" })));
}
export default LogOut;
